import React, { ReactElement } from 'react';
import OverallStatusPage from '../../sharedComponents/overallStatusPage/OverallStatusPage';
import { percentageToTwoDecimalPlaces } from '../../../../utilities/numberFormatters';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';

const ValueAtRiskOverview: React.FC<
  GeneralOverviewPageRenderedComponentProps
> = (props): ReactElement | null => {
  return (
    <OverallStatusPage
      additionalValues={[
        {
          keyName: 'var_value',
          keyTitle: 'VAR Value',
          transformerFunc: (val: number) => percentageToTwoDecimalPlaces(val),
        },
      ]}
      overviewDataPageKey="Value_at_Risk"
      positionDate={props.positionDate}
    />
  );
};

export default ValueAtRiskOverview;
